<template>
  <v-container>
    <v-card
      class="mx-auto my-12"
      max-width="700"
    >
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>

      <v-img
        height="250"
        src="../../assets/video.png"
      ></v-img>

      <v-list color="#EAEFF0">
        <v-list-group
          v-for="module in modules"
          :key="module.name"
          v-model="module.active"
          :prepend-icon="module.action"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="module.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="video in module.videos"
            :key="video.id"
            class="pointer"
            @click="goToRoute(video.id)"
          >
            <v-list-item-avatar>
              <v-icon
                dark
              >mdi-check-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content color="#A9ABAE">
              <v-list-item-title v-text="video.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import ModuleService from '@/services/module/module'

export default {
  name: 'Modulos',
  data: () => ({
    modules: [],
    ModuleService: new ModuleService()
  }),
  mounted () {
    this.loadModules()
  },
  methods: {
    async loadModules () {
      try {
        const { data } = await this.ModuleService.list()
        this.modules = data.map(module => ({
          ...module,
          videos: module.videos.sort((a, b) => a.sort - b.sort),
          action: 'mdi-folder',
          active: false
        }))
      } catch (error) {
        console.log(error)
      }
    },
    goToRoute (id) {
      this.$router.push(`videos/${id}`)
    },
    close () {
      this.modules.forEach(module => {
        if (module.active) {
          module.active = false
          return false
        }
      })
    }
  }
}
</script>
